<template>
  <router-view v-slot="{ Component }" v-if="!isLoadingUser && !isIframe">
    <transition name="fade" mode="out-in" appear>
      <component :is="Component" />
    </transition>
  </router-view>

  <DeleteConfirmModal v-if="!isIframe" />
  <Notification v-if="!isIframe" />
  <ConfirmModal v-if="!isIframe" />

  <Loading
    v-if="!isIframe"
    v-model:active="isLoadingUser"
    :can-cancel="false"
    :is-full-page="true"
    color="#0C1E67"
    loader="dots"
    :opacity="0"
  />

  <teleport to="body">
    <Loading
      v-if="!isIframe"
      :active="isLoadingContent"
      :can-cancel="false"
      :is-full-page="true"
      color="#0C1E67"
      loader="dots"
      :opacity="0.7"
    />
  </teleport>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import sharedData from "@/mixins/sharedData";
import Notification from "@/layouts/Notification.vue";
import Loading from "vue-loading-overlay";
import DeleteConfirmModal from "@/components/Modals/DeleteConfirmModal.vue";
import ConfirmModal from "@/components/Patient/Modal/ConfirmModal.vue";

export default {
  name: "App",
  components: {
    Notification,
    Loading,
    DeleteConfirmModal,
    ConfirmModal,
  },
  mixins: [sharedData],
  computed: {
    ...mapGetters({
      isLoadingUser: "loader/getUserLoaderStatus",
      isLoadingContent: "loader/getContentLoaderStatus",
      currentUser: "user/getCurrentUser",
    }),
  },
  methods: {
    ...mapActions({
      fetchFeatures: "features/fetchFeatures",
    }),
    ...mapMutations({
      setUnreadMessagesCount: "app/setUnreadMessagesCount",
    }),
  },
  watch: {
    currentUser(newValue) {
      if (newValue) {
        window.Intercom("update", {
          name: newValue.full_name,
          email: newValue.email,
          created_at: new Date().valueOf(),
          User_type: "Patient",
          user_hash: newValue.intercom_hash,
        });
      } else {
        window.Intercom("shutdown");
        window.Intercom("boot", {
          api_base: "https://api-iam.intercom.io",
          app_id: process.env.VUE_APP_INTERCOM_APP_ID,
          hide_default_launcher: true,
        });
      }
    },
  },
  created() {
    if (!this.isIframe) {
      this.fetchFeatures();

      window.intercomSettings = {
        app_id: process.env.VUE_APP_INTERCOM_APP_ID,
        custom_launcher_selector: ".write-to-us-in-the-chat",
      };

      window.Intercom("boot", {
        api_base: "https://api-iam.intercom.io",
        app_id: process.env.VUE_APP_INTERCOM_APP_ID,
        hide_default_launcher: true,
      });

      window.Intercom("onUnreadCountChange", (unreadCount) => {
        this.setUnreadMessagesCount(unreadCount);
      });
    }
  },
  mounted() {
    if (this.$route.query._gl) {
      this.$router.replace({
        ...this.$router.currentRoute,
        query: {
          _gl: undefined,
        },
      });
    }
  },
};
</script>
